import React, {  useState } from 'react';
import Lightbox from 'react-image-lightbox';

const ImageBox = ({images})=>{
    const [index, setIndex] = useState(null);
    return (
        <>
           <ul className="imagebox">
                { null!==images &&
                    images.map( (image, key)=>{
                        return (
                        <li key={image.id}>
                            <img src={( null!==(image.thumbnail) && image.thumbnail.startsWith('http://') )?`${image.thumbnail}`:image.thumbnail}
                                    className="list-item img-thumbnail"  alt="섬네일"
                                    onClick={ ()=>setIndex(key) } />
                        </li>
                        )
                    })
                }
            </ul>
            
            { index!==null && 
                <Lightbox
                    mainSrc={( null!==(images[index].path) && images[index].path.startsWith('http://') )?`${images[index].path}`:images[index].path}
                    nextSrc={( null!==(images[(index + 1) % images.length].path) && images[(index + 1) % images.length].path.startsWith('http://') )?`${images[(index + 1) % images.length].path}`:images[(index + 1) % images.length].path}
                    prevSrc={( null!==(images[(index + images.length - 1) % images.length].path) && images[(index + images.length - 1) % images.length].path.startsWith('http://') )?`${images[(index + images.length - 1) % images.length].path}`:images[(index + images.length - 1) % images.length].path}
                        onCloseRequest={() => setIndex(null)}
                        onMovePrevRequest={() => setIndex((index + images.length - 1) % images.length) }
                        onMoveNextRequest={() => setIndex((index + 1) % images.length) }
                />
            }
        </>
    );
}
ImageBox.defaultProps = {
    images:[],
};

export default ImageBox;